import Plyr from "plyr";

export default class VideoPlayer {
	constructor(element) {
		this.element = element;
		let provider =this.element.getAttribute('data-plyr-provider');

		let getCookie = function (name) {
			var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
			if (match) return match[2];
		}

		// init cookie-tool off
		let video_on = true;
		// init cookie-tool on
		if (document.getElementById('eagerly-tools-cookie')) {
			// PART 1/2: Set this to flase to turn on cookies for the vidoe player
			video_on = true;
		}

		// if cookies are set and settings are default
		if (typeof getCookie('cookie_settings') != 'undefined' && getCookie('cookie_settings') == 'default') {
			// PART 2/2: Set this to flase to turn on cookies for the vidoe player
			video_on = true;
		}

		// if cookies are set and settings are not default
		if (typeof getCookie('cookie_settings') != 'undefined' && getCookie('cookie_settings') != 'default') {
			video_on = true;  // YT on
		}

		if (video_on) {
			this.init();
		} else {
			this.element.insertAdjacentHTML("afterbegin", `<div class="js-cookie-btn eagerly-tools-cookie-embed eagerly-tools-cookie-blocked"><span>Je cookie instellingen blokkeren ${provider}.<br> Pas <a class="" href=\"#\">je instellingen</a> aan om gebruik te maken van ${provider}.</span><div class="warning-background"></div>`);
		}
	}

		init() {
			new Plyr(this.element);
		}
	}













